import { jsx as d } from "react/jsx-runtime";
import { S as i } from "../../index-5Bhkapwi.js";
import { c as s } from "../../index-CvSFHqCB.js";
import * as v from "react";
import { c } from "../../utils-BOFVZgHd.js";
const u = s(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[var(--background)] text-[var(--primary)] border-2 border-[var(--primary)] shadow-md hover:bg-[var(--primary)] hover:text-[var(--primary-foreground)]",
        destructive: "bg-[var(--background)] text-[var(--destructive)] border-2 border-[var(--destructive)] shadow-md hover:bg-[var(--destructive)] hover:text-[var(--destructive-foreground)]",
        outline: "border-2 border-[var(--input)] bg-[var(--background)] shadow-sm hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)]",
        secondary: "bg-[var(--background)] text-[var(--secondary)] border-2 border-[var(--secondary)] shadow-md hover:bg-[var(--secondary)] hover:text-[var(--secondary-foreground)]",
        ghost: "hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)] border border-transparent",
        link: "text-[var(--primary)] underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), b = v.forwardRef(
  ({ className: r, variant: e, size: o, asChild: t = !1, ...a }, n) => /* @__PURE__ */ d(t ? i : "button", { className: c(u({ variant: e, size: o, className: r })), ref: n, ...a })
);
b.displayName = "Button";
export {
  b as Button,
  u as buttonVariants
};
//# sourceMappingURL=button.js.map
